// ==================BANK NAMES=================

export const bankNames = [
  {
    id: 19,
    bankCode: "001",
    shortName: "BOT",
    bankNameThai: "ธนาคารแห่งประเทศไทย",
    bankNameEng: "BANK OF THAILAND",
  },
  {
    id: 1,
    bankCode: "002",
    shortName: "BBL",
    bankNameThai: "ธนาคารกรุงเทพ จำกัด (มหาชน)",
    bankNameEng: "BANGKOK BANK PUBLIC COMPANY LTD.",
  },
  {
    id: 2,
    bankCode: "004",
    shortName: "KBANK",
    bankNameThai: "ธนาคารกสิกรไทย จำกัด (มหาชน)",
    bankNameEng: "KASIKORNBANK PUBLIC COMPANY LIMITED",
  },
  {
    id: 3,
    bankCode: "006",
    shortName: "KTB",
    bankNameThai: "ธนาคารกรุงไทย จำกัด (มหาชน)",
    bankNameEng: "KRUNG THAI BANK PUBLIC COMPANY LTD.",
  },
  {
    id: 4,
    bankCode: "011",
    shortName: "TTB TMB",
    bankNameThai: "ธนาคารทหารไทยธนชาต จำกัด (มหาชน)",
    bankNameEng: "TMB THANACHART BANK PUBLIC COMPANY LIMITED",
  },
  {
    id: 5,
    bankCode: "014",
    shortName: "SCB",
    bankNameThai: "ธนาคารไทยพาณิชย์ จำกัด (มหาชน)",
    bankNameEng: "SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.",
  },
  {
    id: 6,
    bankCode: "017",
    shortName: "CITI",
    bankNameThai: "ธนาคารซิตี้แบงก์ เอ็น.เอ.",
    bankNameEng: "CITIBANK, N.A.",
  },
  {
    id: 7,
    bankCode: "020",
    shortName: "StandardCB",
    bankNameThai: "ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)",
    bankNameEng: "STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED",
  },
  {
    id: 8,
    bankCode: "022",
    shortName: "CIMB",
    bankNameThai: "ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)",
    bankNameEng: "CIMB THAI BANK Public Company Limited",
  },
  {
    id: 9,
    bankCode: "024",
    shortName: "UOB",
    bankNameThai: "ธนาคารยูโอบี จำกัด (มหาชน)",
    bankNameEng: "UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED",
  },
  {
    id: 10,
    bankCode: "025",
    shortName: "BAY",
    bankNameThai: "ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)",
    bankNameEng: "BANK OF AYUDHYA PUBLIC COMPANY LTD.",
  },
  {
    id: 11,
    bankCode: "030",
    shortName: "GSB",
    bankNameThai: "ธนาคารออมสิน",
    bankNameEng: "GOVERNMENT SAVINGS BANK",
  },
  {
    id: 12,
    bankCode: "033",
    shortName: "GHB",
    bankNameThai: "ธนาคารอาคารสงเคราะห์	",
    bankNameEng: "THE GOVERNMENT HOUSING BANK",
  },
  {
    id: 13,
    bankCode: "034",
    shortName: "BAAC",
    bankNameThai: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
    bankNameEng: "BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES",
  },
  {
    id: 14,
    bankCode: "052",
    shortName: "BOC",
    bankNameThai: "ธนาคารแห่งประเทศจีน (ไทย) จำกัด (มหาชน)",
    bankNameEng: "BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED",
  },
  {
    id: 15,
    bankCode: "066",
    shortName: "IBT",
    bankNameThai: "ธนาคารอิสลามแห่งประเทศไทย",
    bankNameEng: "ISLAMIC BANK OF THAILAND",
  },
  {
    id: 19,
    bankCode: "067",
    shortName: "TB",
    bankNameThai: "ธนาคารทิสโก้ จำกัด (มหาชน) ",
    bankNameEng: "TISCO BANK PUBLIC COMPANY LIMITED",
  },
  {
    id: 16,
    bankCode: "069",
    shortName: "KKP",
    bankNameThai: "ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)",
    bankNameEng: "KIATNAKIN PHATRA BANK PUBLIC COMPANY LIMITED",
  },
  {
    id: 17,
    bankCode: "070",
    shortName: "ICBC",
    bankNameThai: "ธนาคารไอซีบีซี (ไทย) จำกัด (มหาชน)",
    bankNameEng:
      "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED",
  },
  {
    id: 18,
    bankCode: "073",
    shortName: "LHB",
    bankNameThai: "ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)",
    bankNameEng: "LAND AND HOUSES BANK PUBLIC COMPANY LIMITED",
  },
];

// =========================AMOUNT FORMATE FUNCTION=================

export const toLocaleStringFormate = (value) => {
  // let toLocalStringConvert = value?.toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2})
  var outNumber = Number(value).toLocaleString("en-US", {
    style: "decimal",
    maximumFractionDigits: 8,
    minimumFractionDigits: 8,
  });
  outNumber = outNumber.substring(0, outNumber.indexOf(".") + 3);
  return outNumber;
};


// ================VND BANK LIST=======
export const VNDBankShortnames = {
  "124": "SGB",
  "125": "Sacombank",
  "126": "Agribank",
  "127": "DONGABank",
  "128": "Techcombank (TCB)",
  "129": "GPBank",
  "130": "Bac A Bank",
  "131": "PVcomBank",
  "132": "OCEAN",
  "133": "VietinBank (CTG)",
  "134": "ACB",
  "135": "BIDV",
  "136": "NCB",
  "137": "VRB",
  "138": "MB Bank (MBB)",
  "139": "TPBank",
  "140": "ABBank",
  "141": "MSB",
  "142": "SCB",
  "143": "PGBank",
  "144": "Eximbank",
  "145": "VPBank",
  "146": "INDOVINA",
  "147": "Vietcombank (VCB)",
  "148": "HDBank",
  "149": "BAOVIET",
  "150": "SeABank",
  "151": "VIB",
  "152": "SHB",
  "153": "OCB",
  "154": "LienVietPostBank (LPB)",
  "155": "KienlongBank",
  "156": "UOB",
  "157": "CIMB",
  "362": "PBB",
  "363": "BVBank",
  // "364": "",
  // "365": "",
  // "366": "",
  // "367": "",
  // "368": "",
  // "369": "",
  // "370": "DBS HCMC",
  // "371": "Kookmin HCMC",
  // "372": "Umee Digital Bank",
  // "373": "NongHyup Hanoi",
  // "374": "Kasikornbank HCMC",
  // "375": "KEB Hana HCMC",
  // "376": "Citibank Hanoi",
  // "377": "UBank",
  // "378": "BNP Paribas Hanoi",
  // "379": "KEB Hana Hanoi",
  // "380": "BNP Paribas HCMC",
  // "381": "Cathay United HCMC",
  // "382": "Cambodia Dev & Invest Bank"
};
